<div class="page page-login">
  <div class="card card--dark-lighter">
    <div class="card-body">
      <div class="logo text-center mb-3">
        <img class="w-100" src="{{ 'assets/images/logo.png' }}" />
      </div>
      <!-- <form class="form" #form="ngForm" novalidate>
    <div class="mb-3">
      <label>{{'AUTHENTICATION.USER_NAME' | translate}}</label>
      <input type="text" class="form-control bg-dark" name="username" [(ngModel)]="user.username" #username="ngModel" required>
    </div>
    <div class="mb-3">
      <label>{{'AUTHENTICATION.PASSWORD' | translate}}</label>
      <input type="password" class="form-control bg-dark" name="password" [(ngModel)]="user.password" #password="ngModel" required>
    </div>
    <div *ngIf="showError">
      <small class="error error-message">{{errorMessage | capitalize}}</small>
    </div>
    <div class="mb-3">
      <button class="btn btn-main btn-login" (click)="login()">{{'AUTHENTICATION.LOGIN' | translate | uppercase}}</button>
    </div>
  </form> -->
      <form class="form mat-form" #form="ngForm" (keyup.enter)="login()">
        <input style="display: none" type="email" name="email" />
        <input style="display: none" type="password" name="password" />
        <div class="mb-3">
          <mat-form-field appearance="outline">
            <mat-label>{{ "AUTHENTICATION.USER_NAME" | translate }}</mat-label>
            <input
              matInput
              name="username"
              type="text"
              [(ngModel)]="user.username"
              #username="ngModel"
            />
          </mat-form-field>
        </div>
        <div class="mb-3">
          <mat-form-field appearance="outline">
            <mat-label>{{ "AUTHENTICATION.PASSWORD" | translate }}</mat-label>
            <input
              matInput
              [type]="hide ? 'password' : 'text'"
              autocomplete="off"
              name="password"
              [(ngModel)]="user.password"
              #password="ngModel"
            />
            <button
              mat-icon-button
              type="button"
              matSuffix
              (click)="hide = !hide"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide"
            >
              <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="mb-3">
          <button type="submit" class="btn btn-main w-100" (click)="login()">
            {{ "AUTHENTICATION.LOGIN" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
